import React, { useState, useEffect } from 'react';
import SrchAcc from '../SrchAcc';
import { IconButton } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import { red } from '@material-ui/core/colors';

const SearchAccID = ({ data, onChangeField }) => {
  // We keep the heavy object in local state so the UI knows what to show
  const [localObj, setLocalObj] = useState(data?.value ?? null);

  const handleChangeAccount = accountObj => {
    // 1. Update internal state for UI feedback
    setLocalObj(accountObj);

    // 2. Only output the integer ID to the parent/form state
    onChangeField({
      target: {
        name: data.fld,
        value: accountObj?.ixAcc ?? 0
      }
    });
  };
  function disabled() {
    return data?.disabled ?? false;
  }
  return (
    <SrchAcc
      selectedAcc={{
        // Use the ID from our local ref/state if it exists
        id:
          localObj?.ixAcc ?? (typeof data.value === 'number' ? data.value : 0),
        title: localObj?.sAccTitle ?? ''
      }}
      onSelectAccount={handleChangeAccount}
      error={data?.error ?? false}
      errorMessage={data?.errorMessage ?? ''}
      allowSelectParent={false}
      endAdornment={
        <IconButton
          aria-label="search"
          onClick={e => {
            e.stopPropagation();
            handleChangeAccount({
              ixAcc: 0,
              sAcc: ''
            });
          }}
          size={'medium'}
          disabled={disabled()}
        >
          <Clear
            fontSize={'medium'}
            style={{
              color: disabled() ? 'rgba(0, 0, 0, 0.38)' : red[500]
            }}
          />
        </IconButton>
      }
      {...(data?.rest ?? {})}
    />
  );
};

export default SearchAccID;
